import { render } from "./permission-list.html?vue&type=template&id=8880565a&scoped=true&ts=true"
import script from "./permission-list.ts?vue&type=script&lang=ts"
export * from "./permission-list.ts?vue&type=script&lang=ts"

import "./permission-list.scss?vue&type=style&index=0&id=8880565a&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8880565a"]])

export default __exports__